import custom from "../../../assets/img/partnerPortal/welcomePage/innovate.png";
import gartner_banner from "../../../assets/img/partnerPortal/welcomePage/gartner_banner.png";
import perform_banner from "../../../assets/img/partnerPortal/welcomePage/perform_banner.jpg";

import News from "../../../models/common/News";
import Contact from "../../../models/common/Contact";
import Item from "../../../models/common/Item";
import Banner from "../../../models/common/Banner";

// BANNER
export const TITLE = (
  <div>
    Welcome to your<br></br>Partner Portal
  </div>
);
// export const ABOVE_TITLE = "PREMIER PARTNER"
export const BUTTON_NAME = "Register a deal";
export const BUTTON_LINK = "https://partners.dynatrace.com/#/page/sales";
// --

// BANNERS
const banner0: Banner = new Banner(
  "https://www.dynatrace.com/gartner-magic-quadrant-for-observability-platforms/?utm_med[…]race&utm_campaign=partner&utm_content=portal&utm_term=q2fy25",
  "_parent",
  "100%",
  gartner_banner
);
const banner1: Banner = new Banner(
  "https://partners.dynatrace.com/#/page/perform-2025-on-demand",
  "_parent",
  "100%",
  perform_banner
);
const banner2: Banner = new Banner(
  "https://www.dynatrace.com/innovate/?utm_medium=partner&utm_source=dynatrace&utm_campaign=innovate&utm_content=partner-portal&utm_term=25",
  "_parent",
  "100%",
  custom
);
export const ALL_BANNERS: Array<Banner> = new Array<Banner>(banner0, banner1);

// CONTACTS

const dynaContact1: Contact = new Contact(
  "Michael Allen",
  "VP Global Partner Sales",
  "michael.allen@dynatrace.com",
  "Tel. +44 162 861 1014"
);
const dynaContact2: Contact = new Contact(
  "Julie Bateman",
  "Channel & Alliance Director, ANZ",
  "julie.bateman@dynatrace.com",
  "Tel. +61 043-131-2207"
);
const dynaContact3: Contact = new Contact(
  "Laurent Gaudy",
  "Sr. Director, EMEA Alliances",
  "laurent.gaudy@dynatrace.com",
  "Tel. +33 677-977-280"
);
const dynaContact4: Contact = new Contact(
  "Kacey Leckenby",
  "Global Alliance Director, NORAM",
  "kacey.leckenby@dynatrace.com",
  "Tel. +1 310-487-9074"
);
const dynaContact5: Contact = new Contact(
  "Alejandro Musgrove",
  "Senior Director LATAM Partners",
  "alejandro.musgrove@dynatrace.com",
  "Tel. +1 954-684-3117"
);
const dynaContact6: Contact = new Contact(
  "Alex Lim",
  "Senior Director APAC Partners",
  "alex.lim@dynatrace.com",
  "Tel. +65 833-959-68"
);
export const ALL_DYNA_CONTACT_LIST: Array<Contact> = new Array<Contact>(
  dynaContact1,
  dynaContact2,
  dynaContact3,
  dynaContact4,
  dynaContact5,
  dynaContact6
);

const partnerContact2: Contact = new Contact(
  "Paul Barnhill",
  "Managing Director Cloud Engineering",
  "pbarnhill@deloitte.com",
  ""
);
// const partnerContact3: Contact = new Contact("Michael Di Camillo", "Director, Platform Engineering", "mdicamillo@deloitte.com.au", "");
export const ALL_PARTNER_CONTACT_LIST: Array<Contact> = new Array<Contact>(
  partnerContact2
);
// --

// NEWS AND EVENTS
const news33: News = new News(
  "Perform and Innovate Sponsor Prospectus FY26",
  "https://partners.dynatrace.com/content/8a99822b95b0e7e80195b4734ee018f8",
  true,
  true,
  true,
  undefined,
  "Read more"
);
const news32: News = new News(
  "Watch Perform on-demand​",
  "https://www.dynatrace.com/perform/",
  true,
  true,
  true,
  undefined,
  "Watch now"
);
const news31: News = new News(
  "Dynatrace Introduces Observability for Developers​",
  "https://www.dynatrace.com/news/press-release/dynatrace-introduces-observability-for-developers/",
  true,
  true,
  true,
  undefined,
  "Read more"
);
const news30: News = new News(
  "Dynatrace Partners with Visa Cash App Racing Bulls (VCARB) Formula One™ Team​",
  "https://www.dynatrace.com/news/press-release/dynatrace-partners-with-visa-cash-app-racing-bulls-vcarb-formula-one-team-as-official-observability-performance-analytics-technology-partner/",
  true,
  true,
  true,
  undefined,
  "Read more"
);
const news29: News = new News(
  "Streaming event: Dynatrace & the Power of Possible​",
  " https://webinars.techstronglearning.com/dynatrace-and-the-power-of-possible?utm_medium=partner&utm_source=dynatrace&utm_campaign=virtual-event&utm_content=portal&utm_term=q3fy25",
  true,
  true,
  true
);
const news28: News = new News(
  "Partners lead with Dynatrace SaaS​",
  "https://partners.dynatrace.com/#/collateral/8a9983ce90d6f9a50190f221a5f121bd",
  false,
  true,
  true
);
const news26: News = new News(
  "Dynatrace named a Leader in the 2024 Gartner® Magic Quadrant™ for Observability Platforms​",
  "https://www.dynatrace.com/gartner-magic-quadrant-for-observability-platforms/?utm_medium=partner&utm_source=dynatrace&utm_campaign=partner&utm_content=portal&utm_term=q2fy25",
  false,
  true,
  true
);
const event17: News = new News(
  "Learn how to master the Dynatrace Partner Deliver Toolkit",
  "https://info.dynatrace.com/noram-all-wb-partner-delivery-toolkit-26404-od-fulfillment.html?utm_medium=partner&utm_source=dynatrace&utm_campaign=portal&utm_content=all-active-partners&utm_term=none&mkt_tok=MzUyLU5WTy01NjIAAAGY5uZvOiRelPaOTN3vSicEXtUu1G4fcCPHd0QPVHj8YbfjrjGTV3GCMjiUFZaQKdEbZlgiU3boBximTOnaZiQb",
  true,
  true,
  true,
  "On-Demand Webinar",
  "Watch now"
);
const event13: News = new News(
  "Key highlights from Perform 2025",
  "https://partners.dynatrace.com/#/page/perform-2025-on-demand",
  true,
  true,
  true,
  "On-Demand Webinar",
  "Watch now"
);

export const ALL_EVENTS_LIST: Array<News> = new Array<News>(
  news33,
  news32,
  news31,
  news30,
  news29,
  news28,
  news26,
  event17,
  event13
);

// ITEMS
const item1: Item = new Item(
  "Metcash simplifies critical business workflows with Dynatrace® and Deloitte",
  "View PDF",
  "https://partners.dynatrace.com/#/collateral/8a9983cf8e1b6d3a018e1ee05e367be7"
);
const item2: Item = new Item(
  "State Health Insurance Marketplace delivers seamless access to health coverage with Deloitte and Dynatrace",
  "View PDF",
  "https://partners.dynatrace.com/#/collateral/8a9983cf8e1b6d3a018e1ee07a307c12"
);
const item3: Item = new Item(
  "Deloitte Digital turns to Dynatrace to enable seamless digital journeys for clients and internal team",
  "View PDF",
  "https://partners.dynatrace.com/#/collateral/8a9993aa8e12e37b018e1945a1bf6d4f"
);
export const ALL_ITEMS_LIST: Array<Item> = new Array<Item>(item1, item2, item3);

// TOOLS
const tool1: Item = new Item(
  "Deloitte Australia Observability Practice Brochure",
  "View PDF",
  "https://partners.dynatrace.com/#/collateral/8a998a608e12e37a018e1e0077dc5918"
);
const tool2: Item = new Item(
  "Quick Reference Guide - CloudOps Automation",
  "View PDF",
  "https://partners.dynatrace.com/#/collateral/8a998a608e12e37a018e1dd0280e31ee"
);
const tool3: Item = new Item(
  "Quick Reference Guide - Intelligent Observability",
  "View PDF",
  "https://partners.dynatrace.com/#/collateral/8a9983cf8e1b6d3a018e1dd0089a2480"
);

export const ALL_TOOLS_LIST: Array<Item> = new Array<Item>(tool1, tool2, tool3);
